// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","control":"Home_control__l3iw5","form_control":"Home_form_control__vN201","invalid":"Home_invalid__8ekvr","actions":"Home_actions__n7Xqd"};